import { render, staticRenderFns } from "./staff_access_form.vue?vue&type=template&id=0da84698&scoped=true"
import script from "./staff_access_form.vue?vue&type=script&lang=js"
export * from "./staff_access_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da84698",
  null
  
)

export default component.exports